<template>
    <div>
        <div
            v-for="(ttpp, index) in ttppList"
            :key="ttpp.id || index"
            class="ttpp-entry mb-3"
        >
            <Dropdown
                v-model="ttppList[index].id"
                :options="filteredTTPPOptions(ttpp.id)"
                optionLabel="fullname"
                optionValue="id"
                filter
                filterBy="fullname"
                @filter="fetchTTPP"
                @change="validateUniqueness(index)"
                placeholder="Pilih Tim Teknis Perencanaan Pengadaan"
            />
            <button
                @click="removeTTPP(index)"
                class="px-4 py-2 bg-red-500 text-white rounded ml-2"
            >
                Hapus
            </button>
        </div>
        <button
            @click="addTTPP"
            type="button"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah TTPP
        </button>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_ttpp: Array,
    },
    data() {
        // const ttppInitialList = this.list_ttpp
        //     ? this.list_ttpp.map((item, idx) => ({
        //         ...item,
        //        ttppUniqueId: item.ttppUniqueId || this.ttppGenerateUniqueId(),
        //        ttppDisplayIndex: idx + 1
        //    }))
        //    : [];
        return {
            ttppOptions: [],
            ttppList: this.list_ttpp ? [...this.list_ttpp] : [],
        };
    },
    watch: {
        list_ttpp: {
            handler(ttppNewValue) {
                    this.ttppList = ttppNewValue ? [...ttppNewValue] : [];
            },
            deep: true,
        },
        ttppList: {
            handler(ttppNewValue) {
                // Emit the updated ttppList to the parent component
                this.$emit("update:list_ttpp", ttppNewValue);
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchTTPP({ value: "" });
    },
    methods: {
        addTTPP() {
            this.ttppList.push({ id: null });
            this.ttppNextIndex++;
            console.log('Updated list:', this.ttppList);
            //console.log("Berhasil klik");
        },
        removeTTPP(ttppIndex) {
            this.ttppList.splice(ttppIndex, 1);
        },
        async fetchTTPP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ttpp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ttppOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ttpp:", error);
            }
        },
        filteredTTPPOptions(ttppCurrentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.ttppOptions.concat(
                this.ttppList.filter(
                    (p) =>
                        p.id === ttppCurrentId &&
                        !this.ttppOptions.some(
                            (option) => option.id === ttppCurrentId
                        )
                )
            );
        },
        validateUniqueness(ttppCurrentIndex) {
            const ttppCurrentId = this.ttppList[ttppCurrentIndex]?.id;
            if (
                ttppCurrentId &&
                this.ttppList.filter(
                    (ttpp) => ttpp.id === ttppCurrentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "TTPP duplikat terdeteksi. Pastikan setiap ttpp unik.",
                    life: 3000,
                });
                this.ttppList[ttppCurrentIndex].id = null;
            }
        },
    },
});
</script>
